import * as THREE from 'three';
import p5 from "p5";
import { QTree } from './QTree';
import { DrawerBase } from './DrawerBase';
import { Random } from '../../data/Random';

export class QTreeDrawer extends DrawerBase{

    p5:p5;
    qTree:QTree;
    count:number=0;
   

    constructor(tgt:p5){
        super();
        this.p5 = tgt;
        this.qTree = new QTree();
        
        let nn = 5;
        if(Random.value<0.6){
            nn=5;
        }else{
            nn=4;
        }

        this.qTree.update(nn);

        this.rects = this.qTree.rects;
    }

    show(): void {
        super.show();
        this.count=0;
    }

    hide(): void {
        super.hide();
    }

    update(){        
        this.rects = this.qTree.rects;
        let rect =  this.rects[this.count% this.rects.length];
        if(this.count< this.rects.length) rect.show();
        for(let i=0;i< this.rects.length;i++){
            this.rects[i].update(this.p5);
        }
        this.count++;
    }

}